// fetchMeLivestreamRating.js
'use strict';

import getMeData from '../selector/getMeData.js';
import getLiveStreamData from '../selector/getLiveStreamData.js';
import getNetworkingData from '../selector/getNetworkingData.js';

import fetch from '../resource/customFetch.js';
import getResourceUrl from '../resource/getResourceUrl.js';
import { getHeaders } from '../resource/fetchOptionHeader.js';
import handleFetchError from '../resource/handleFetchError.js';

import {
  MERGE_LIVE_STREAM_DATA,
  SET_NETWORKING_FETCHING,
  SET_NETWORKING_SUCCESS,
  SET_NETWORKING_ERROR,
} from '../ActionTypes.js';

/**
 * Fetch me livestream rating
 * @kind action
 * @param {string} {streamId} - stream id.
 * @return {Promise} Action promise.
 */
const fetchMeLivestreamRating =
  ({ streamId } = {}) =>
  async (dispatch, getState) => {
    const sessionId = getLiveStreamData(getState(), [streamId], 'sessionId');
    const networkingSelectPath = [
      'fetch',
      'livestream',
      streamId,
      'ratedAs',
      sessionId,
    ];
    const token = getMeData(getState(), 'token');
    const isFetching = getNetworkingData(
      getState(),
      networkingSelectPath,
      'isFetching'
    );
    if (!token || !streamId || !sessionId || isFetching) {
      return dispatch({ type: '' });
    }
    const fetchOptions = {
      method: 'GET',
      headers: {
        ...getHeaders(),
        Authorization: `Bearer ${token}`,
      },
    };
    const fetchUrl = getResourceUrl({
      endpoint: `/sessions/${sessionId}/rate`,
    });
    dispatch({
      type: SET_NETWORKING_FETCHING,
      payload: { selectPath: networkingSelectPath },
    });
    try {
      let response = await fetch(fetchUrl.href, fetchOptions);
      if (!response.ok) {
        response = await handleFetchError({
          response,
          dispatch,
          getState,
          fetchOptions,
          fetchUrl,
        });
      }
      const { rating } = (await response.json()) || {};
      dispatch({
        type: MERGE_LIVE_STREAM_DATA,
        payload: {
          selectPath: [streamId, 'rating', sessionId],
          data: {
            ratedAs: rating,
          },
        },
      });
      return dispatch({
        type: SET_NETWORKING_SUCCESS,
        payload: { selectPath: networkingSelectPath },
      });
    } catch (error) {
      return dispatch({
        type: SET_NETWORKING_ERROR,
        payload: { selectPath: networkingSelectPath, error },
      });
    }
  };

export default fetchMeLivestreamRating;
